import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  myForm!: UntypedFormGroup;
  isLoader = false;

  showNewPassword = false;
  showConfirmPassword = false;
  confirmPassword = '';

  formValid = false;

  // Password requirements for template
  requirements = [
    { label: 'At least 8 characters', valid: false, id: 'length' },
    { label: 'One uppercase letter', valid: false, id: 'uppercase' },
    { label: 'One lowercase letter', valid: false, id: 'lowercase' },
    { label: 'One number', valid: false, id: 'number' },
    { label: 'One special character', valid: false, id: 'special' },
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private route: Router,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.myForm = this.formBuilder.group({
      password: ['', [Validators.required, this.passwordValidator()]],
      confirmPassword: ['', Validators.required]
    },  { validator: this.MustMatch('password', 'confirmPassword') });

    this.myForm.valueChanges.subscribe(() => {
      this.checkFormValidity();
      this.validatePassword();
    });
  }

  get fc() {
    return this.myForm.controls
  }

  MustMatch(ctrlName: string, matchVal: string) { /* Password Match */
    return (formGroup: FormGroup) => { const control = formGroup.controls[ctrlName], matchingControl = formGroup.controls[matchVal];
      if (matchingControl.errors && !matchingControl.errors['mustMatch'])
        return;
      if (control.value !== matchingControl.value)
        matchingControl.setErrors({ mustMatch: true });
      else
        matchingControl.setErrors(null);
    }
  }

  passwordValidator() {
    return Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|<>]).{8,}$/);
  }

  // Renamed to match your template's method call
  validatePassword(): void {
    const password = this.myForm.get('password')?.value || '';

    const tests = {
      length: /.{8,}/.test(password),
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|<>]/.test(password),
    };

    this.requirements.forEach(req => {
      req.valid = tests[req.id as keyof typeof tests] || false;
      // Also update icons in DOM if needed, or just rely on Angular binding
    });
  }

  togglePassword(field: 'newPassword' | 'confirmPassword'): void {
    if (field === 'newPassword') {
      this.showNewPassword = !this.showNewPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  checkFormValidity(): void {
    const password = this.myForm.get('password')?.value;
    const confirm = this.confirmPassword;
    this.formValid = this.myForm.valid;
  }

  async submit(form: UntypedFormGroup) {
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched(), this.toastr.warning("New password and confirm password fields are required.") // Correct way to mark all fields
      return
    } else {
      const password = form.get('password')?.value;
      const confirmPassword = form.get('confirmPassword')?.value;
  
      if (password !== confirmPassword) {
        this.toastr.warning('Passwords do not match.');
        return;
      }
  
      this.isLoader = true;
   const encryptedPassword = await this.commonService.encryptAesGcm(
      password,
      this.commonService.secretKey,
    );
      const payload = {
        userid: localStorage.getItem('UserId'),
        password: encryptedPassword
      };
  
      this.commonService.postCall(`Registration/UpdateUserPassWord`, payload).subscribe({
        next: () => {
          this.toastr.success('Password Changed Successfully');
          this.isLoader = false;
          this.signOut();
        },
        error: (err) => {
          this.toastr.error(err.error || 'Password Not Changed');
          this.isLoader = false;
        }
      });
    }

    // if (form.invalid) {
    //   this.toastr.error('Please correct the form before submitting');
    //   return;
    // }

   
  }

  signOut(): void {
    this.clearToken();
    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      this.route.navigate(['/login']);
    }, 500);
  }

  clearToken(): void {
    this.commonService.postCall('Account/ClearToken', {
      UserID: localStorage.getItem('UserId')
    }).subscribe();
  }

  goBack(): void {
    window.history.back();
  }
}
